import { render, staticRenderFns } from "./SupportingVulnerableSeniors.vue?vue&type=template&id=5d8f54e0&"
import script from "./SupportingVulnerableSeniors.vue?vue&type=script&lang=js&"
export * from "./SupportingVulnerableSeniors.vue?vue&type=script&lang=js&"
import style0 from "./SupportingVulnerableSeniors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports